export default __webpack_public_path__ + "static/media/tree.b86d2734.svg";